import React, { useEffect, useRef, useState } from "react";
import Conversation from "./Conversation";
import { useAuth } from "../../../../Context/Auth";
import { updateMessageStatus } from "../../../../API/ChatLayer";
import InfiniteScroll from "react-infinite-scroll-component";
import { useChatLayer } from "../../../../API/useChatLayer";

const Conversations = React.memo(() => {
  const {
    wpDetails,
    setChatData,
    setSelectedChat,
    setConversationspage,
    conversations,
    moreConversations,
    selectedChat,
    conversationListScroll,
    setConversationListScroll,
    dropDownFlag,
    contactFlag,
    chatSearchKey,
  } = useAuth();
  const { getContactChatList } = useChatLayer();

  const scrollableDivRef = useRef(null);
  const [userHasScrolled, setUserHasScrolled] = useState(false);
  const prevConversationsLengthRef = useRef(0);
  const listFilterKey = `${dropDownFlag}-${contactFlag}-${chatSearchKey}`;

  const scrollValueRef = useRef(conversationListScroll);
  useEffect(() => {
    scrollValueRef.current = conversationListScroll;
  }, [conversationListScroll]);

  const clickHandler = (data) => {
    if (data?.total_unread_messages !== 0) {
      data.total_unread_messages = 0;
      setSelectedChat(data);
      updateMessageStatus(wpDetails, data)
        .then((res) => {
          console.log("Status Update");
        })
        .catch((error) => {
          console.log("Failed to update status", error);
        });
    }
    setSelectedChat(data);
    setConversationspage("chatContent");
    setChatData(null);
  };

  const scrollHandler = () => {
    if (!userHasScrolled) return;
    getContactChatList(null, true);
  };

  useEffect(() => {
    setUserHasScrolled(false);
    prevConversationsLengthRef.current = 0;
  }, [listFilterKey]);

  // Track scroll position before update and save to context
  useEffect(() => {
    const handleScroll = () => {
      setUserHasScrolled(true);
      if (scrollableDivRef.current) {
        setConversationListScroll(scrollableDivRef.current.scrollTop);
      }
    };

    const div = scrollableDivRef.current;
    if (div) {
      div.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (div) {
        div.removeEventListener("scroll", handleScroll);
      }
    };
  }, [setConversationListScroll]);

  // Restore scroll only when the list grows from pagination, not on filter refresh
  useEffect(() => {
    const div = scrollableDivRef.current;
    const currentLength = conversations?.length || 0;
    const prevLength = prevConversationsLengthRef.current;
    prevConversationsLengthRef.current = currentLength;

    if (!div) return;

    if (currentLength > prevLength && prevLength > 0) {
      return;
    }

    requestAnimationFrame(() => {
      div.scrollTop = conversationListScroll || 0;
    });
  }, [conversations]);

  return (
    <div className="chatContact" id="scrollableDiv" ref={scrollableDivRef}>
      <InfiniteScroll
        key={listFilterKey}
        dataLength={conversations?.length || 0}
        next={scrollHandler}
        style={{ display: "flex", flexDirection: "column" }}
        hasMore={
          userHasScrolled &&
          Boolean(moreConversations?.current_page) &&
          conversations?.length < moreConversations?.count
        }
        loader={
          <h4 style={{ textAlign: "center", marginTop: "100px" }}>
            Loading...
          </h4>
        }
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>--*--</b>
          </p>
        }
        scrollableTarget="scrollableDiv"
      >
        {conversations?.map((data) => (
          <p
            key={data.id}
            onClick={() => {
              clickHandler(data);
            }}
            style={{
              background: data.id === selectedChat?.id ? "#f2f2f2" : "",
            }}
          >
            <Conversation data={data} />
          </p>
        ))}
      </InfiniteScroll>
    </div>
  );
});

export default Conversations;
